import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import "../../Vender/css/Destinations.css";

const MountAbu = () => {
  const [cookies] = useCookies(["token", "user", "id"]);

  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhone] = useState("");

  const user_id = cookies.id;

  const handlePayment = async () => {
    if (!amount || !name || !email || !phone_no) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const res = await fetch(
        "/api/payment_details/create-order",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: parseFloat(amount) }),
        },
      );

      const data = await res.json();

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: data.amount * 100,
        currency: data.currency,
        name: "Aacore Resorts And Hospitality Pvt. Ltd.",
        description: "Mount Abu Booking",
        order_id: data.orderId,
        handler: async function (response) {
          const verifyRes = await fetch(
            "/api/payment_details/verify-payment",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                amount: parseFloat(amount),
                name,
                email,
                phone_no,
                user_id,
              }),
            },
          );

          const verifyData = await verifyRes.json();
          if (verifyData.success) {
            alert("Payment successful 🎉");
            setShowModal(false);
          } else {
            alert("Payment failed ❌");
          }
        },
        prefill: { name, email, contact: phone_no },
        theme: { color: "#3399cc" },
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.open();
    } catch (err) {
      alert("Payment initialization failed.");
    }
  };

  const hotels = [
    {
      name: "Hillock Hotel",
      img: "Hillock Hotel.jpg",
      desc: "Luxury hillside hotel offering stunning valley views, comfortable rooms and peaceful surroundings in Mount Abu.",
    },
    {
      name: "Cama Rajputana",
      img: "Cama Rajputana.jpg",
      desc: "Heritage palace hotel surrounded by lush gardens, blending royal Rajasthani architecture with modern comfort.",
    },
  ];

  return (
    <section id="destination">
      <div 
        className="mountabu py-5"
        style={{
          backgroundImage: "url('/assets/images/Mount_Abu.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "300px"
        }}
      >
        <nav aria-label="breadcrumb" style={{ position: "relative", zIndex: 2 }}>
          <ol className="breadcrumb" style={{ backgroundColor: "transparent", padding: "10px" }}>
            <li className="breadcrumb-item text-light">
              <Link to="/" className="text-light">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item active text-light">Mount Abu</li>
          </ol>
        </nav>
      </div>

      <div className="container py-5">
        <h1 className="text-center mb-4">Our Hotel Partners in Mount Abu</h1>

        <div className="row justify-content-center">
          {hotels.map((hotel, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card">
                <img
                  src={`/assets/images/${hotel.img}`}
                  className="card-img-top"
                  alt={hotel.name}
                  style={{ height: "250px", objectFit: "cover" }}
                />
                <div className="card-body">
                  <h5 className="card-title">{hotel.name}</h5>
                  <p className="card-text">{hotel.desc}</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowModal(true)}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Book Mount Abu Tour</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  placeholder="Amount"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Phone"
                  value={phone_no}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlePayment}>
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default MountAbu;
